// PrivacyPolicy.js
import React from 'react';
import './CSS/PrivacyPolicy.css'; // Import CSS for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 className="privacy-policy-title">Privacy Policy</h1>
      <p className="effective-date"><strong>Effective Date:</strong> January 16, 2025</p>

      <section className="privacy-policy-section">
        <h2>1. Information We Collect</h2>
        <p>We collect and process the following types of information:</p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email, phone number, reservation information.</li>
          <li><strong>Usage Information:</strong> Details on how you interact with our website.</li>
          <li><strong>Cookies and Tracking Technologies:</strong> We use cookies to improve your experience on our site.</li>
        </ul>
      </section>

      <section className="privacy-policy-section">
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To process reservations and payments.</li>
          <li>To improve customer service and our website.</li>
        </ul>
      </section>

      <section className="privacy-policy-section">
        <h2>3. Sharing Your Information</h2>
        <p>We may share your information with third-party service providers (e.g., payment processors) or if required by law.</p>
      </section>

      <section className="privacy-policy-section">
        <h2>4. Data Security</h2>
        <p>We use industry-standard security measures to protect your personal data, but cannot guarantee complete security.</p>
      </section>

      <section className="privacy-policy-section">
        <h2>5. Your Rights</h2>
        <p>You have the right to access, update, delete, or opt-out of marketing communications at any time.</p>
      </section>

      <section className="privacy-policy-section">
        <h2>6. Third-Party Links</h2>
        <p>We are not responsible for the privacy practices of external websites linked on our platform.</p>
      </section>

      <section className="privacy-policy-section">
        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update this policy from time to time, and any changes will be posted on this page.</p>
      </section>

      <section className="privacy-policy-section">
        <h2>8. Contact Us</h2>
        <p>If you have any questions or concerns, feel free to reach out to us via email at <strong>info@moonsiderooms.co.uk</strong> or call <strong>0175 476 5119</strong>.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
